import GuiContext from "config/context/guiContext";
import { useContext, useEffect, useRef } from "react";

// Sesija na serveru živi kratko (sliding TTL). Dok korisnik radi, front na
// aktivnost javlja backendu da produži prozor; čim utihne, ništa ga ne
// produžava i istekne. Refresh se NE sme vezati za tajmer bez aktivnosti —
// to bi držalo sesiju večno i poništilo celu svrhu.
//
// Zašto najviše jednom u 5 min: aktivnost okida često (pomeranje miša, skrol),
// a produžetak je isti bez obzira koliko puta ga tražimo u prozoru. Poređenje
// vremena je jeftino; `fetch` ide samo kad je razmak prošao. Posledica: pošto
// se poslednji refresh desi unutar 5 min pre nego što korisnik ode, stvarni
// idle-istek padne između (TTL − 5 min) i TTL.
const REFRESH_MIN_INTERVAL_MS = 5 * 60 * 1000;

const DOGADJAJI = ["mousedown", "keydown", "scroll", "touchstart", "mousemove"];

export const useSessionKeepalive = () => {
  const { userData, logOut } = useContext(GuiContext);
  const prijavljen = Boolean(userData?.accounts);
  const poslednjiRef = useRef(0);

  useEffect(() => {
    if (!prijavljen) return undefined;

    const url = process.env.REACT_APP_API_URL || window.location.origin;
    let otkazan = false;

    const produzi = async () => {
      const sada = Date.now();
      if (sada - poslednjiRef.current < REFRESH_MIN_INTERVAL_MS) return;
      poslednjiRef.current = sada;
      try {
        const res = await fetch(`${url}/api/inerygui/refresh`, {
          method: "POST",
          credentials: "include",
        });
        // Istekao ili nestao kolačić: server je rekao „ne znam ko si". Sesija je
        // gotova — odjava vodi na prijavu, umesto da korisnik ostane u ljusci
        // koja će na sledećem čitanju svejedno pasti na 401.
        if (res.status === 401 && !otkazan) logOut();
      } catch (error) {
        // Mrežni promašaj se NE tumači kao istek — ne odjavljujemo zbog
        // trenutnog prekida; sledeća aktivnost će pokušati ponovo.
      }
    };

    // Prvi produžetak tek posle isteka razmaka: login je već izdao svež kolačić.
    poslednjiRef.current = Date.now();
    for (const dog of DOGADJAJI) window.addEventListener(dog, produzi, { passive: true });

    return () => {
      otkazan = true;
      for (const dog of DOGADJAJI) window.removeEventListener(dog, produzi);
    };
  }, [prijavljen, logOut]);
};
